module.exports = __webpack_public_path__ + "static/media/30-2.711a5fd6.mp3";